export default __webpack_public_path__ + "static/media/avatar_indian_boy5.92d9f77c.mp3";